import { Mic, MicOff, Square } from "lucide-react";

/**
 * Voice-mode controls below the avatar.
 * Listening status is shown by VoiceModeVisual — no separate listening indicator here.
 *
 * Recording / muted: [mic] [stop]
 * Between turns (not muted): [start mic]
 */
export default function VoiceModeControls({
  isRecording = false,
  isMicMuted = false,
  isLoading = false,
  onToggleMicMute,
  onStopRecording,
  onStartVoiceMode,
}) {
  const showSessionControls = isRecording || isMicMuted;

  return (
    <div className="ob-vcontrols">
      <div className="ob-vpill">
        {showSessionControls ? (
          <>
            <button
              type="button"
              onClick={onToggleMicMute}
              disabled={isLoading}
              className={`ob-vbtn ${isMicMuted ? "ob-vbtn-muted" : "ob-vbtn-live"}`}
              aria-label={isMicMuted ? "Unmute microphone" : "Mute microphone"}
              title={
                isMicMuted ? "Unmute and start listening" : "Mute microphone"
              }
            >
              {isMicMuted ? (
                <MicOff style={{ width: 16, height: 16 }} />
              ) : (
                <Mic style={{ width: 16, height: 16 }} />
              )}
              {/* A live mic earns a pulse; a muted one must look inert. */}
              {!isMicMuted && <span className="ob-vbtn-ping" aria-hidden="true" />}
            </button>

            <span className="ob-vlabel">
              {isMicMuted ? "Mic off" : "Mic live"}
            </span>

            <button
              type="button"
              onClick={onStopRecording}
              disabled={isLoading}
              className="ob-vbtn ob-vbtn-stop"
              aria-label="End voice conversation"
              title="End voice conversation"
            >
              <Square style={{ width: 14, height: 14, fill: "currentColor" }} />
            </button>
          </>
        ) : (
          <>
            <button
              type="button"
              onClick={onStartVoiceMode}
              disabled={isLoading}
              className="ob-vbtn ob-vbtn-live"
              aria-label="Start speaking"
              title="Start speaking"
            >
              <Mic style={{ width: 16, height: 16 }} />
            </button>
            <span className="ob-vlabel">Tap to talk</span>
          </>
        )}
      </div>
    </div>
  );
}
